class ResAcc {
  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.js-res-acc-item')
    this.buttons = this.el.querySelectorAll('.js-res-acc-button')
    this.contents = this.el.querySelectorAll('.js-res-acc-content')

    this.initDefaults()
  }

  initDefaults () {
    this.initContentState()
    this.initEvents()
  }

  initEvents () {
    this.buttons.forEach(el => {
      el.addEventListener('click', e => this.toggle(e))
    })
  }

  toggle (e) {
    e.preventDefault()
    if (e.target.classList.contains('js-tabs-btn')) return;
    const target = e.currentTarget
    const $item = $(target).parents('.js-res-acc-item')
    const $content = $item.find('.js-res-acc-content')

    if ($item.hasClass('active')) {
      $item.removeClass('active')
      $content.slideUp(300).promise().done(() => {
        $content.css({ 'display': 'none' })
      })
    } else {
      $(this.items).removeClass('active')
      $(this.contents).slideUp(300).promise().done(() => {
        $(this.contents).css({ 'display': 'none' })
      })
      $item.addClass('active')
      $content.slideDown(300).promise().done(() => {
        $content.css({ 'display': 'block' })
      })
    }
  }

  initContentState () {
    this.items.forEach(el => {
      const content = el.querySelector('.js-res-acc-content')
      el.classList.contains('active') ? content.style.display = 'block' : content.style.display = 'none'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-res-acc')

  if (el) {
    new ResAcc(el)
  }
})